import { SET_LAYOUT } from './constants';

const INITIAL_STATE = {
  layout: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_LAYOUT: {
      return {
        ...state,
        layout: action.payload
      };
    }
    default:
      return state;
  }
};

export default reducer;
